// Route assignment-edit inline form (D3j). Used by LogisticsRoutesDetailCard
// to swap a rig and/or override the driver at scheduling time. Pure
// presentation -- all state lives in useLogisticsRouteAssignmentEdit.
import { ghostBtnClass, inputClass, primaryBtnClass } from "./logisticsRoutesShared";
import type { useLogisticsRouteAssignmentEdit } from "./useLogisticsRouteAssignmentEdit";

type Props = {
  a: ReturnType<typeof useLogisticsRouteAssignmentEdit>;
};

export function LogisticsRoutesAssignmentEditForm({ a }: Props) {
  return (
    <div className="mt-2 rounded-lg border border-indigo-200/60 bg-indigo-50/40 p-3 dark:border-indigo-800/60 dark:bg-indigo-950/20">
      <div className="text-xs font-semibold uppercase tracking-wide text-indigo-700 dark:text-indigo-300 mb-2">
        Edit rig + driver
      </div>
      {a.submitError ? (
        <div className="mb-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-900 dark:border-red-800 dark:bg-red-950/35 dark:text-red-100">
          {a.submitError}
        </div>
      ) : null}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <label className="block text-xs text-gray-600 dark:text-zinc-300">
          Rig
          <select
            className={`${inputClass} mt-1`}
            value={a.draftRigId}
            onChange={(e) => a.setDraftRigId(e.target.value)}
            disabled={a.rigsLoading || a.submitBusy}
          >
            <option value="">
              {a.rigsLoading
                ? "(loading rigs…)"
                : a.rigs.length === 0
                  ? "(carrier has no active rigs)"
                  : "(no rig — leave unassigned)"}
            </option>
            {a.rigs.map((r) => (
              <option key={r.id} value={r.id}>
                {r.designation}
                {r.standard_driver_name ? ` — ${r.standard_driver_name}` : ""}
              </option>
            ))}
          </select>
        </label>
        <label className="block text-xs text-gray-600 dark:text-zinc-300">
          Driver (overrides rig&apos;s standard driver)
          <input
            className={`${inputClass} mt-1`}
            value={a.draftDriverName}
            onChange={(e) => a.setDraftDriverName(e.target.value)}
            disabled={a.submitBusy}
            placeholder="Driver name for this run"
          />
        </label>
      </div>
      <div className="mt-2 flex flex-wrap gap-2">
        <button
          type="button"
          className={primaryBtnClass}
          onClick={() => void a.submit()}
          disabled={a.submitBusy}
        >
          {a.submitBusy ? "Saving…" : "Save assignment"}
        </button>
        <button
          type="button"
          className={ghostBtnClass}
          onClick={a.cancelEdit}
          disabled={a.submitBusy}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
